import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';
import './Auth.css';

const API_URL = '/api';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function ResetPassword() {
  const query = useQuery();
  const navigate = useNavigate();
  const initialToken = query.get('token') || '';
  const [token, setToken] = useState(initialToken);
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [message, setMessage] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage(null);
    if (!token) return setMessage('Token requis');
    if (password.length < 6) return setMessage('Le mot de passe doit contenir au moins 6 caractères');
    if (password !== confirm) return setMessage('Les mots de passe ne correspondent pas');

    setLoading(true);
    try {
      await axios.post(`${API_URL}/auth/reset`, { token, password });
      setMessage('Mot de passe réinitialisé. Vous pouvez maintenant vous connecter.');
      setTimeout(() => navigate('/login'), 1500);
    } catch (err) {
      setMessage(err.response?.data?.message || 'Erreur lors de la réinitialisation');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <h1>Réinitialisation du mot de passe</h1>
          <p>Collez votre token de réinitialisation et choisissez un nouveau mot de passe.</p>
        </div>

        <form onSubmit={handleSubmit} className="auth-form">
          {message && <div className="auth-error">{message}</div>}

          <div className="form-group">
            <label>Token</label>
            <input type="text" value={token} onChange={(e) => setToken(e.target.value)} placeholder="token de réinitialisation" required />
          </div>

          <div className="form-group">
            <label>Nouveau mot de passe</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••" required />
          </div>

          <div className="form-group">
            <label>Confirmer le mot de passe</label>
            <input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} placeholder="••••••" required />
          </div>

          <button type="submit" className="btn-auth" disabled={loading}>
            {loading ? 'Traitement...' : 'Réinitialiser le mot de passe'}
          </button>
        </form>
      </div>
    </div>
  );
}
